<div class="rm-header">
  <span>Email Body & Links</span>
</div>
<mat-dialog-content>
    <p [innerHTML]="data.emailBody"></p>
    <div style="margin-top: 20px;">
        <div style="margin-bottom: 10px;">
            <b>Button Text:</b> <br />
            {{data.buttonText}}
        </div>
        <div>
            <b>Button URL:</b> <br />
            {{data.buttonUrl}}
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; justify-content: center;">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
